import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ReservationPluginService } from './reservation-plugin.service';


@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {

  private appConfig;

  constructor(private http: HttpClient, private reservationPluginService: ReservationPluginService) {}

  public loadAppConfig() {
    return new Promise((resolve, reject) => {
      this.http.get('assets/config.json').subscribe(
        data => {
          this.appConfig = data;
          this.reservationPluginService.setAppBase(this.appConfig);
          resolve(true);
        }
      );
    });
  }
}
